// extracted by mini-css-extract-plugin
export default {"buttonTopMargin":"ChangeEmail_buttonTopMargin__iTqja","emailPage":"ChangeEmail_emailPage__E-bSI","userSpan":"ChangeEmail_userSpan__jMTTy"};